import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import "./index.css";
import i18n from "./i18n";
import App from "./App";

console.log({
  prod: import.meta.env.PROD,
  dev: import.meta.env.DEV,
  url: import.meta.env.VITE_API_BASE_URL,
});

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
